// extracted by mini-css-extract-plugin
export default {"legalContainer":"Legal_legalContainer__ZF+dV","lastUpdated":"Legal_lastUpdated__nrrDa","legalContent":"Legal_legalContent__yw1X1"};